import React, { useContext } from "react";
import styled from "styled-components";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const StyledAdditionalFields = styled(AdditionalFields)`
  margin: 0 0 35px;
`;
const FormAdvancedOptions = ({ onChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { mimecastThrottleEnabled } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(StyledAdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "mimecastThrottleEnabled",
      type: "checkbox",
      value: "enable-throttling",
      defaultChecked: mimecastThrottleEnabled == null ? void 0 : mimecastThrottleEnabled.value,
      onChange,
      label: "Enable Throttling",
      help: "If enabled, no new messages will be read from this input until the server catches up with its message load. This is typically useful for inputs reading from files or message queue systems like AMQP or Kafka. If you regularly poll an external system, e.g. via HTTP, you normally want to leave this disabled."
    }
  ));
};
export default FormAdvancedOptions;
